var o1 = "/static/bc891f5777fa26b1.png";

export { o1 as default };
//# sourceMappingURL=o_1.png.js.map
